module.exports = __webpack_public_path__ + "img/glyphicons-halflings-regular.8988968.f7214668.svg";